(
    function (skyward, $, undefined)
    {
        var updateNear = function ()
        {
            var element = $(this);

            $(".NearScreeningDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updateFar = function ()
        {
            var element = $(this);

            $(".FarScreeningDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updatePaFarScreeningDistance = function ()
        {
            var element = $(this);

            $(".FarVisualAcuityLeftEyeDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updatePaNearScreeningDistance = function ()
        {
            var element = $(this);
            
            $(".NearVisualAcuityLeftEyeDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var init = function (selector)
        {
            $(selector + ' .FarVisionScreeningDistance').on('change', updateFar);
            $(selector + ' .NearVisionScreeningDistance').on('change', updateNear);
            $(selector + ' .FarVisualAcuityRightEyeDistance').on('change', updatePaFarScreeningDistance);
            $(selector + ' .NearVisualAcuityRightEyeDistance').on('change', updatePaNearScreeningDistance);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);